import React from 'react'
import './AboutUs.css'

const AboutUs = () => {
  return (
    <div className='about_container'> 
      <div className='welcome'>
        <h2>We have been working since 2023</h2>
        <h3>Welcome to <span>Top Fashion</span>, an online store based in Nairobi, Kenya.</h3>
        <p>At <span>Top Fashion</span>, we believe that fashion is not just about clothing;
           it's a form of self-expression, a way to empower individuals, and a means to embrace diversity and creativity.
           We are passionate about bringing you fashion that goes beyond the runway and fits seamlessly into your everyday life.
        </p>
      </div >
      <div className='mission'>
        <h3>Our Mission</h3>
        <p>Our mission is to inspire and elevate your style journey. We curate collections that blend timeless elegance 
          with contemporary trends, ensuring that our pieces stand the test of time both in terms of quality and style.
          We believe in fashion that tells a story, reflects your personality, and makes you feel confident.
        </p>
      </div>
      <div className='choose'><h3>Why Choose <span>Top Fashion</span></h3></div>
      <div className='values'>
        
        <div className='quality'>
          <img src="./img/quality-service.png" alt="qualityservice"/>
          <h4>Quality and Craftsmanship</h4>
          <p>Each piece in our collection is crafted with precision and attention to detail. We source the finest
             materials to create clothing that not only looks good but also feels incredible to wear.
          </p>

        </div>

        <div className='integrity'>
          <img src="./img/integrity.png" alt="integrity"/>
          <h4>Integrity</h4>
          <p>We hold ourselves to the highest standard.We deliver what we say we will deliver.</p>

        </div>

        <div className='inclusivity'>
          <img src="./img/size.png" alt="size"/>
          <h4>Inclusivity</h4>
          <p>Fashion knows no boundaries, and neither do we. Our diverse range of sizes, styles, and designs cater to 
            every individual, celebrating the uniqueness of every body type and personal taste.
          </p>

        </div>
        <div className="moved-to-next-row">
            <div className='trust'>
                <img src="./img/trust.png" alt="trust"/>
               <h4>Trust</h4>
               <p>We expect customers to trust our drivers and other service providers ,so we need to trust one another
                  in every thing we do.
               </p>

            </div>

            <div className='sustainability'>
               <img src="./img/sustainability.png" alt="sustainability"/>
               <h4>Sustainability</h4>
               <p>We are committed to sustainable fashion practices. From eco-friendly materials to responsible production
                  processes, we are dedicated to reducing our environmental footprint.
              </p>

             </div>

             <div className='customer-centric approach'>
                <img src="./img/customer-service.png" alt="customer"/>
                <h4>Customer-Centric Approach</h4>
                <p>Your satisfaction is our priority. Our dedicated customer support team is here to assist you with any
                  questions or concerns, ensuring a seamless shopping experience.
                </p>
             </div>
         </div>
      

        

        


      </div>
      <div className='journey'>
        <h3>Join Us on this Fashion Journey</h3>
        <p>We invite you to explore our collections, get inspired by our lookbooks, and become a part of the
           Top Fashion community. Follow us on social media, share your style with us using <span>#TopFashionStyle</span>,
           and let's embark on a fashionable journey together.</p>
      </div>

    </div>
  )
}

export default AboutUs